import React from 'react';
import { message } from 'antd';
import { Button } from 'ui-kit';
import { getDashboardLink, refreshAccountLink } from 'api/stripe';

interface IStripeActionButtonProps {
  payoutMethodId: number;
  mode: 'create' | 'edit';
  isOnboardingComplete: boolean;
  disabled: boolean;
}

const StripeActionButton = ({
  payoutMethodId,
  mode,
  isOnboardingComplete,
  disabled = false,
}: IStripeActionButtonProps) => {
  if (mode === 'create') {
    return (
      <button className="stripe-connect" type="submit" disabled={disabled}>
        <span>Connect with</span>
      </button>
    );
  }

  const redirectToStripeDashboard = () => {
    getDashboardLink(payoutMethodId)
      .then((res) => {
        if (res.ok) {
          window.open(res.data.url, '_blank');
        } else {
          message.error('Something went wrong redirecting to Stripe! Please try again later.');
        }
      })
      .catch((err) => {
        message.error(err.message);
      });
  };

  const redirectToOnboarding = () => {
    refreshAccountLink(payoutMethodId);
  };

  const onClick = isOnboardingComplete ? redirectToStripeDashboard : redirectToOnboarding;

  return (
    <Button variant="text" className="stripe-dashboard-button" onClick={onClick} color="textDark">
      {isOnboardingComplete ? 'Visit Stripe Dashboard' : 'Complete Stripe Onboarding'}
    </Button>
  );
};

export default StripeActionButton;
